import { useAtom } from '../../../lib';
import { latestBlockAtom } from '../../../atoms';
import { Icon, Link, Typography } from '../../shared';

import './MobileFooter.scss';

const MobileFooter = () => {
  const [latestBlock] = useAtom(latestBlockAtom);

  return (
    <div className="nostra__mobileFooter">
      <div className="nostra__mobileFooter__links">
        <Link href="https://discord.gg/zwa8K3drb">
          <Icon variant="discord" size={12} color="--icon-supporting" />
        </Link>
        <Link href="https://twitter.com/nostrafinance">
          <Icon variant="x" size={12} color="--icon-supporting" />
        </Link>
        <Link href="https://docs.nostra.finance/">
          <Icon variant="git-book" size={12} color="--icon-supporting" />
        </Link>
      </div>
      <div className="nostra__mobileFooter__status">
        <Typography variant="body-sm" color="text-supporting">
          {latestBlock}
        </Typography>
        <div className="nostra__navigation__serviceStatusIcon" />
      </div>
    </div>
  );
};
export default MobileFooter;
